import type { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
  BrowserIdStorage,
  LoginRefreshTokenStorage,
  LoginTokenStorage,
} from '../auth/authentication';
import { config } from '../config/index';
import { logger } from '../logger';

const DEBUG = false;

const HTTP_TOKEN_HEADER = config.httpHeaderKeys.token;
const HTTP_TOKEN_CLEAR_HEADER = config.httpHeaderKeys.tokenClear;
const HTTP_REFRESH_TOKEN_HEADER = config.httpHeaderKeys.refreshToken;

/**
 * Axios Response 인터셉터
 * HTTP 헤더에서 인증 토큰을 추출하여 로컬 저장소에 보관한다
 * 또는 인증 토큰을 제거한다
 */
export const apiResponseInterceptor = (
  response: AxiosResponse,
): AxiosResponse | Promise<AxiosResponse> => {
  if (!response.headers) return response;

  let clearRequired = false;
  const clearAuth = response.headers[HTTP_TOKEN_CLEAR_HEADER];
  if (clearAuth && clearAuth.length > 0) {
    if (LoginTokenStorage.exists()) {
      clearRequired = true;
    }
  }

  const refreshToken = response.headers[HTTP_REFRESH_TOKEN_HEADER] as string | undefined;
  if (refreshToken) {
    LoginRefreshTokenStorage.value = refreshToken;
    clearRequired = false;
  }

  const newToken = response.headers[HTTP_TOKEN_HEADER] as string | undefined;
  if (newToken && newToken.length > 0) {
    if (DEBUG) logger.log(`SAVE AUTH HEADER: ${newToken}`);
    clearRequired = false;
    const oldToken = LoginTokenStorage.value;
    if (oldToken !== newToken) {
      if (DEBUG) {
        console.log('신규 인증 토큰:', newToken, ', old=', oldToken);
      }
      LoginTokenStorage.value = newToken;
    } else {
      if (DEBUG) {
        console.log('동일한 인증 토큰 무시:', newToken);
      }
    }
  }

  if (clearRequired) {
    LoginRefreshTokenStorage.clear();
    LoginTokenStorage.clear();
    if (DEBUG) {
      console.debug('REMOVE AUTH HEADER');
    }
  }

  return response;
};

/**
 * 인증 토큰 HTTP 헤더를 생성한다
 */
export const createApiHeader = (): Record<string, string> => {
  const headers = {} as Record<string, string>;
  const token = LoginTokenStorage.value;
  if (token && token.length > 0) {
    headers['Authorization'] = 'Bearer ' + token;
  }
  let browserId = BrowserIdStorage.value;
  // console.log("XXX curr 브라우저ID", browserId);
  if (!browserId) {
    browserId = uuidv4();
    BrowserIdStorage.value = browserId;
  }
  headers['x-custom-device'] = browserId;

  // console.log("createApiHeader", headers);
  return headers;
};
